
export default function ErrorMessage({ message }: { message: string; }) {
    return (
        <div style={{ textAlign: "center", padding: "30px 0", fontSize: "1.14em" }}> 
            { message } 
        </div> 
    )
}